import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Loader from 'components/_UI/Loader';
import ticketsApi from 'api/requests/tickets';
import { Column } from 'styled/alignment/Column';
import SalesPanel from '../../_sales/SalesPanel';

const COPY = {
    // A develop rotulava este card como "Ingressos vendidos" também aqui,
    // por cópia do arquivo de ingressos.
    soldLabel: 'Produtos vendidos',
    iconName: 'label',
    sectionTitle: 'Desempenho por produto',
    sectionSubtitle: 'Quanto cada produto vendeu, arrecadou e ainda tem em estoque.',
    sortLabel: 'Ordenar produtos',
    hiddenLabel: 'Produto oculto',
    emptyText: 'Nenhum produto cadastrado para este evento.',
};

export default function ProductDetail({ data }) {
    const [payload, setPayload] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getProducts(data);
    }, [data]);

    async function getProducts(slug) {
        setIsLoading(true);

        try {
            const { data: response } = await ticketsApi.getTicketForEvent(slug);
            setPayload(response);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return (
            <ContentLoader>
                <Loader />
            </ContentLoader>
        );
    }

    /* Diferente de ingressos, o payload de produtos não traz o recorte
       online/PDV — por isso `channels` fica de fora e os chips de canal
       não são renderizados. */
    return (
        <SalesPanel
            items={payload?.products || []}
            copy={COPY}
            totals={{
                sold: payload?.products_sold,
                total: payload?.products_total,
                revenueSold: payload?.products_revenue_sold,
                revenuePotential: payload?.products_revenue_total,
            }}
        />
    );
}

const ContentLoader = styled(Column)`
    min-height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
